import { useState } from 'react'
import { Button } from '@/shared/ui/button'
import { Dialog } from '@/shared/ui/dialog'
import { useDeleteMeeting } from '../model/use-delete-meeting'

interface DeleteMeetingControlProps {
  meetingId: string
  // Вызывается после успешного удаления — странице деталей больше нечего
  // показывать, она уводит на список.
  onDeleted?: () => void
}

export function DeleteMeetingControl({ meetingId, onDeleted }: DeleteMeetingControlProps) {
  const [open, setOpen] = useState(false)
  const mutation = useDeleteMeeting(meetingId)

  function run() {
    mutation.mutate(undefined, {
      onSuccess: () => {
        setOpen(false)
        onDeleted?.()
      },
    })
  }

  return (
    <>
      <Button variant="danger" size="sm" onClick={() => setOpen(true)}>
        Удалить встречу
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} title="Удалить встречу">
        <p className="text-sm text-text-secondary">
          Встреча будет удалена безвозвратно вместе с записями и транскриптом. Отменить это действие
          нельзя.
        </p>
        <div className="mt-4 flex justify-end gap-3">
          <Button variant="secondary" size="sm" onClick={() => setOpen(false)}>
            Не сейчас
          </Button>
          <Button variant="danger" size="sm" disabled={mutation.isPending} onClick={run}>
            Удалить
          </Button>
        </div>
      </Dialog>
    </>
  )
}
